import cx from "clsx";
import React from "react";
import { NewsletterForm, SocialMediaIcons } from "../../../components/common";
import { FundraisingRegulator } from "../../../components/common/Icons";
import LinkNoStyle from "../../../components/common/LinkNoStyle/LinkNoStyle";

import { DataLayerWrapper } from "../../../components/DataLayerWrapper/DataLayerWrapper";
import { isSpecificSite } from "../../../utils/isSpecificSite";
import * as styles from "./Footer.module.scss";

export interface FooterProps {
	footerLinks?: DogsTrust.Link[];
	customComponent?: React.ReactNode;
}
export const Footer: React.FC<FooterProps> = ({
	customComponent,
	footerLinks = [],
}) => {
	isSpecificSite("uk", "Footer");
	return (
		<div className={styles.footerwrapper}>
			<div className={styles.footercomponent}>
				<div
					className={cx({
						[styles.footertop]: !customComponent,
						[styles.footertopcustom]: customComponent,
					})}
				>
					<div className={styles.usefullinkswrapper}>
						<h2 className={styles.usefullinkstitle}>Useful links</h2>
						<div className={styles.links}>
							{footerLinks.map((link) => (
								<DataLayerWrapper
									key={link.title}
									event={"menu_navigation"}
									menu_level={"footer"}
									menu_clicked={link.title}
									menu_url={link.url}
								>
									<LinkNoStyle
										key={link.title}
										className={styles.link}
										to={link.url}
									>
										{link.title}
									</LinkNoStyle>
								</DataLayerWrapper>
							))}
						</div>
					</div>
					<div className={styles.sectionbreaktop} />
					<div className={styles.newsletterwrapper}>
						{customComponent ? (
							customComponent
						) : (
							<NewsletterForm
								title="Sign up for our newsletter"
								body="Get top dog training tips and behaviour advice straight to your inbox, as well as fun activities and plenty of pupdates."
								url={"/sign-up"}
							/>
						)}
					</div>
				</div>
				<div className={styles.sectionbreakmiddle} />
				<div className={styles.footerbottom}>
					<div className={styles.socialmediawrapper}>
						<SocialMediaIcons
							xUrl="https://twitter.com/DogsTrust"
							facebookUrl="https://www.facebook.com/DogsTrust"
							instagramUrl="https://www.instagram.com/dogstrust/"
							youtubeUrl="https://www.youtube.com/user/DogsTrust"
							tikTokUrl="https://www.tiktok.com/@dogstrust"
							linkedInUrl="https://www.linkedin.com/company/dogs-trust"
						/>
					</div>
					<div className={styles.sectionbreakbottom} />
					<div className={styles.bottomwrapper}>
						<div className={styles.legalwrapper}>
							<h3 className={styles.legalwrapperheader}>
								© {new Date().getFullYear()} Dogs Trust
							</h3>
							<p className={styles.legalwrapperp}>
								Registered Charity Numbers: 1167663 and SC053144 &#38; Company
								No. 09365971. Donations are tax exempt and Gift Aid can be
								claimed.
							</p>
						</div>
						<div className={styles.fundraiseregswrapper}>
							<FundraisingRegulator width={"190px"} height={"60px"} />
						</div>
						<button
							type="button"
							id="ot-sdk-btn"
							className={cx(styles.cookiebutton, "ot-sdk-show-settings")}
						>
							Cookie Settings
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
